import { useEffect, useState, useRef } from 'react'

import { newHomepageService } from 'Pods/NewHomepage/Services/newHomepageService'

const useTrendingModels = ({ perPage = 8 } = {}) => {
  const [trendingModels, setTrendingModels] = useState([])
  const sectionRef = useRef(null)
  const [hasLoaded, setHasLoaded] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        if (entry.isIntersecting && !hasLoaded) {
          setHasLoaded(true)
          const fetchTrendingModels = async () => {
            const data = await newHomepageService.getTrendingModels(perPage)
            setTrendingModels(data)
          }
          fetchTrendingModels()
        }
      },
      {
        rootMargin: '300px',
        threshold: 0.1,
      }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [hasLoaded, perPage])

  return {
    trendingModels,
    sectionRef,
  }
}

export default useTrendingModels
